import { Theme } from '@material-ui/core';

export interface LogoProps {
  applyTheme?: boolean;
  fullWidth?: boolean;
  width?: number;
  height?: number;
  maxWidth?: number;
  fillColor?: string;
}

export interface SelectiveLogoProps extends LogoProps {
  isOpen: boolean;
}

export const getFillColor = (theme: Theme, applyTheme: boolean): string => {
  if (applyTheme) return theme.palette.type === 'light' ? '#001D21' : '#D6D4C9';
  return '#D6D4C9';
};
